import { DogColor } from '@margembie-labradors/shared';

export const ALPHABET_ONLY_REGEX = /^[A-Za-z ]+$/i;

export const COLOR_CHECKBOX_OPTIONS = [
  {
    label: 'Any',
    value: 'any',
  },
  {
    label: 'Yellow',
    value: DogColor.YELLOW,
  },
  {
    label: 'Black',
    value: DogColor.BLACK,
  },
  {
    label: 'Chocolate',
    value: DogColor.CHOCOLATE,
  },
];
